export default __webpack_public_path__ + "static/media/rosmarino_01.09891628.png";